<template>
  <div class="box">
      <img src="@/assets/topbg1.png" alt="" style="width:100%;position: absolute;top: 0;left: 0;">
      <div class="box-margin">
          <div class="content-box">
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>产品名称</div>
                  <div class="pub-input">
                      <input
                          style="background: #00000000;"
                          type="text"
                          class="input-gh"
                          v-model="productName"
                          placeholder="请填写产品名称"
                      />
                  </div>
              </div>
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>产品价格</div>
                  <div class="pub-input">
                      <input
                          style="background: #00000000;"
                          type="text"
                          class="input-gh"
                          v-model="productPrice"
                          placeholder="请填写产品价格"
                      />
                  </div>
              </div>
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>规格型号</div>
                  <div class="pub-input">
                      <input
                          style="background: #00000000;"
                          type="text"
                          class="input-gh"
                          v-model="specModel"
                          placeholder="请填写规格型号"
                      />
                  </div>
              </div>
              <div class="box-item1">
                    <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"><span style="color: red">*</span>产品类型</div>
                    <div>
                        <div class="user-type" @click="isUserDkzyj('HO')" style="width: 30%;">
                            <div
                                style="font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;"
                                :style="
                                    dkzyj == 'HO'
                                        ? 'color:#272929;color:#FF8626;background: rgba(255,134,38,0.1);border: 1px solid #FF8828;' : 'color:#9A9B9E;'"
                            >
                            气动卡钳
                            </div>
                        </div>
                        <div class="user-type" @click="isUserDkzyj('ELK')" style="width: 30%;">
                            <div
                                style="font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;"
                                :style="
                                    dkzyj == 'ELK'
                                        ? 'color:#272929;color:#FF8626;background: rgba(255,134,38,0.1);border: 1px solid #FF8828;' : 'color:#9A9B9E;'"
                            >
                            电控单元
                            </div>
                        </div>
                        <div class="user-type" @click="isUserDkzyj('JZZY')" style="width: 30%;">
                            <div
                            style="font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;"
                                :style="
                                    dkzyj == 'JZZY'
                                        ? 'color:#272929;color:#FF8626;background: rgba(255,134,38,0.1);border: 1px solid #FF8828;' : 'color:#9A9B9E;'"
                            >
                            精准注油机
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-item1">
                    <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"><span style="color: red">*</span>销售件/备用件</div>
                    <div>
                        <div class="user-type" @click="isUserSxby('XS')">
                            <div
                                style="font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;"
                                :style="
                                    sxby == 'XS'
                                        ? 'color:#272929;color:#FF8626;background: rgba(255,134,38,0.1);border: 1px solid #FF8828;' : 'color:#9A9B9E;'"
                            >
                            销售件
                            </div>
                        </div>
                        <div class="user-type" @click="isUserSxby('BY')">
                            <div
                            style="font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;"
                                :style="
                                    sxby == 'BY'
                                        ? 'color:#272929;color:#FF8626;background: rgba(255,134,38,0.1);border: 1px solid #FF8828;' : 'color:#9A9B9E;'"
                            >
                                备用件
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>出厂日期</div>
                  <div class="pub-input" style="cursor: pointer" @click="selCcrq">
                      <div
                          class="title"
                          :style="ccrq !== '' ? 'color:#272929;' : ''"
                      >
                          {{
                              ccrq == "" ? "请选择交付日期" : ccrq
                          }}
                      </div>
                      <img
                          src="@/assets/tmp-17812-6TNqofyWPA7Y-.png"
                          alt=""
                          class="btm-icon"
                      />
                  </div>
              </div>
              <!-- <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>机器序号</div>
                  <div class="pub-input">
                      <input
                          type="text"
                          class="input-gh"
                          v-model="xh"
                          placeholder="请填写机器序号"
                      />
                  </div>
              </div> -->
              <!-- <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>交付日期</div>
                  <div class="pub-input" style="cursor: pointer" @click="selQwrq">
                      <div
                          class="title"
                          :style="qwrqText !== '' ? 'color:#272929;' : ''"
                      >
                          {{
                              qwrqText == "" ? "请选择交付日期" : qwrqText
                          }}
                      </div>
                      <img
                          src="@/assets/tmp-17812-6TNqofyWPA7Y-.png"
                          alt=""
                          class="btm-icon"
                      />
                  </div>
              </div> -->
              
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>质保年限</div>
                  <div  @click="selZjlx" class="pub-input" style="cursor: pointer;">
                      <div
                          class="title"
                          :style="
                              JSON.stringify(zjlxObj) !== '{}'
                                  ? 'color:#272929;'
                                  : ''
                          "
                      >
                          {{
                              JSON.stringify(zjlxObj) == "{}"
                                  ? "请选择质保年限"
                                  : zjlxObj.text
                          }}
                      </div>
                      <img
                          src="@/assets/tmp-17812-6TNqofyWPA7Y-.png"
                          alt=""
                          class="btm-icon"
                      />
                  </div>
              </div>
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>客户名称</div>
                  <div  @click="selCustomer" class="pub-input" style="cursor: pointer;">
                      <div
                          class="title"
                          :style="
                              JSON.stringify(customerObj) !== '{}'
                                  ? 'color:#272929;'
                                  : ''
                          "
                      >
                          {{
                              JSON.stringify(customerObj) == "{}"
                                  ? "请选择客户"
                                  : customerObj.name
                          }}
                      </div>
                      <img
                          src="@/assets/tmp-17812-6TNqofyWPA7Y-.png"
                          alt=""
                          class="btm-icon"
                      />
                  </div>
              </div>
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red"></span>联系电话</div>
                  <div class="pub-input">
                      <input
                      
                          type="text"
                          class="input-gh"
                          v-model="customerObj.mobile"
                          placeholder="请填写联系电话"
                      />
                  </div>
              </div>
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red"></span>备注</div>
                  <div class="pub-input" style="height: auto;">
                    <textarea
                        type="text"
                        class="input-xq"
                        style="background: #00000000;padding: 12px 20px;height:200px;box-sizing: border-box;"
                        v-model="remarks"
                        placeholder="在这里输入备注"
                    />
                  </div>
              </div>
              <div>
                  <div
                      class="share-url"
                      @click="submitOrEditData">
                      确定
                  </div>
              </div>
          </div>
          <div style="height: 15px"></div>
      </div>
      <van-popup v-model="showZjlxPopup" position="bottom">
          <div style="width: 100%">
              <van-picker
                  title="请选择"
                  show-toolbar
                  :columns="zjlxCom"
                  @confirm="onConfirm"
                  @cancel="onCancel"
              />
          </div>
      </van-popup>
      <van-popup v-model="showQwyyPopup" position="bottom">
          <div style="width: 100%">
              <van-picker
                  title="请选择"
                  show-toolbar
                  :columns="jzyyCom"
                  @confirm="onConfirm1"
                  @cancel="onCancel1"
              />
          </div>
      </van-popup>
      <van-popup v-model="showCustomerPopup" position="bottom">
          <div style="width: 100%;display: flex;flex-direction: column;">
            <div style="width: 100%;height: 60px;display: flex;align-items: center;justify-content: center;background: #f7f7f7;">
                <input type="text" name="" id="" class="ips" v-model="cusKeyword" @input="searchCustomer" placeholder="客户名称搜索">
            </div>
            <div style="height: 380px;overflow-y: scroll;">
                <div v-for="item in customerList" :key="item.id" style="height: 39px;line-height: 39px;;font-size: 16px;font-weight: 600;padding: 5px 15px;;" @click="sureCustomer(item)">{{ item.name }} - {{ item.person }}</div>
            </div>
            
          </div>
      </van-popup>
      <div class="loading" v-show="isLoading">
          <van-loading text-color="#1DA9A4" color="#1DA9A4" vertical
              >加载中...</van-loading
          >
      </div>
      <van-calendar
          v-model="showCalendar"
          :show-confirm="false"
          :min-date="new Date(2019,1,1)"
          :title="'请选择日期'"
          :color="'#079bab'"
          @confirm="selectCalendar"
      />
      <van-popup v-model="showQwrqPopup" round position="bottom">
          <div style="width: 100%">
              <van-picker
                  title="请选择就诊时间段"
                  show-toolbar
                  :columns="columns"
                  @confirm="onsjdConfirm"
                  @cancel="onsjdCancel"
              />
          </div>
      </van-popup>
  </div>
</template>
<script>
import { user } from "@/api";
import Config from "@/config";
import authImg from "@/components/temp/authImg.vue";
let lsDate = "";
import _ from 'lodash';
import {
  Popup,
  Picker,
  ImagePreview,
  Loading,
  Toast,
  Empty,
  Dialog,
  Calendar,
} from "vant";
import dayjs from "dayjs";
// import { compressImage } from "@/utils/CompressImageUtils";
let timer = null;
export default {
  components: {
      authImg,
      VanLoading: Loading,
      VanPopup: Popup,
      VanPicker: Picker,
      VanEmpty: Empty,
      VanCalendar: Calendar,
  },
  data() {
      return {
          Config,
          token:'',
          showCustomerPopup: false,
          productName:"",
          productPrice:"",
          specModel:"",
          customerName:"",
          customerMobile:"",
          showDialog: false,
          showTxDialog: false,
          showCalendar: false,
          fontSizeValue: 0,
          qwrqText: "",
          minDate: "",
          maxDate: "",
          columns: [
              "8:00-9:00",
              "9:00-10:00",
              "10:00-11:00",
              "13:30-14:30",
              "14:30-15:30",
              "15:30-16:30",
          ],
          showQwrqPopup: false,
          status: "",
          remarks: "",
          isAllFalse: false,
          isSel: 2,
          isVip: true,
          hisId: "",
          isLoading: false,
          sex: 1, // 性别 1男2女
          dkzyj:'HO',
          sxby:'XS',
          ccrq: dayjs().format("YYYY-MM-DD"),
          xh:"",
          jzlb: 1,
          realName: "", // 真实名称
          idCardNumber: "", // 证件号码
          mobile: "", // 联系电话
          age: "", // 年龄
          jzxq: 1, // 就诊需求
          zjlx: "", // 证件类型
          zjlxObj: {
            text: '1年',
            title:"1年",
            value: 1
          }, // 证件类型
          customerObj:{},
          qwyy: "", // 期望医院
          qwyyObj: {}, // 期望医院
          tsRemark: "",
          zjlxCom: [{
            text: "1年",
            title:"1年",
            value: 1
          }, {
            text: "2年",
            title:"2年",
            value: 2
          }, {
            text: "3年",
            title:"3年",
            value: 3
          }, {
            text: "4年",
            title:"4年",
            value: 4
          }, {
            text: "5年",
            title:"5年",
            value: 5
          }, {
            text: "6年",
            title:"6年",
            value: 6
          }, {
            text: "7年",
            title:"7年",
            value: 7
          }, {
            text: "8年",
            title:"8年",
            value: 8
          }, {
            text: "9年",
            title:"9年",
            value: 9
          }, {
            text: "10年",
            title:"10年",
            value: 10
          }],
          jzyyCom: [],
          slhCom: {},
          jyjcbgList: [],
          jyjcbgStringList: [],
          showZjlxPopup: false,
          showQwyyPopup: false,
          qywxId: "",
          failEdit: true, //是否可以填写
          isCurrentTime: false,
          saleId:"",
          customerList: [],
          cusKeyword: ""
      };
  },
  mounted() {
    // console.log(dayjs("2023-10-12").format("YY-MM-DD"))
    // let date = new Date(2015,1,1);
    //   this.minDate = new Date(date);
      this.isLoading = false;
      if(this.getQueryString("sale")) {
        this.saleId = JSON.parse(this.getQueryString("sale")).id;
        this.productName = JSON.parse(this.getQueryString("sale")).productName;
        this.productPrice = JSON.parse(this.getQueryString("sale")).productPrice;
        this.specModel = JSON.parse(this.getQueryString("sale")).specModel;
        this.qwrqText = JSON.parse(this.getQueryString("sale")).deliveryDate;
        this.zjlxObj.value = JSON.parse(this.getQueryString("sale")).warrantyDate;
        this.zjlxObj.text = JSON.parse(this.getQueryString("sale")).warrantyDate + '年';
        this.customerObj.name = JSON.parse(this.getQueryString("sale")).customerName;
        this.customerObj.mobile = JSON.parse(this.getQueryString("sale")).customerMobile;
        this.remarks = JSON.parse(this.getQueryString("sale")).remarks;
        this.dkzyj = JSON.parse(this.getQueryString("sale")).dkzyj;
        this.sxby = JSON.parse(this.getQueryString("sale")).sxby;
        this.ccrq = '20' + JSON.parse(this.getQueryString("sale")).ccrq;
        this.xh = JSON.parse(this.getQueryString("sale")).xh;
      }
      document.title = "填写信息";this.getHisList()
      
  },
  methods: {
    sureCustomer(e) {
        this.customerObj = e;
        this.showCustomerPopup = false
    },
    searchCustomer(e) {
        this.cusKeyword = e.target.value;
        clearTimeout(timer);
            timer = setTimeout(() => {
                this.getHisList()
            }, 200);
	},
    getHisList() {
			user.getCustomerList({page: 1,pageSize: 500, keyword: this.cusKeyword}).then(res => {
				if(res.data.code == 200) {
					this.customerList = res.data.data.resultList;
				}
			})
		},
      getMe() {
          let params = {
              code: this.getQueryString("code"),
          };
          user.wcLogin(params).then(res => {
              if(res.data.code == 200) {
                  localStorage.setItem("userInfo", JSON.stringify(res.data.data.user));
                  localStorage.setItem("token", res.data.data.access_token);
              }
          })
      },
      getMasterDataAc() {
          user.getManyMasterDataDetail({code: ['SYJ002','SYJ003']}).then(res => {
              if(res.data.code == 200) {
                  this.zjlxCom = []
                  this.jzyyCom = []
                  for(let i in res.data.data.SYJ002) {
                      this.zjlxCom.push({
                          text: res.data.data.SYJ002[i].name,
                          title: res.data.data.SYJ002[i].name,
                          value: res.data.data.SYJ002[i].name,
                      })
                  }
                  for(let i in res.data.data.SYJ003) {
                      this.jzyyCom.push({
                          text: res.data.data.SYJ003[i].name,
                          title: res.data.data.SYJ003[i].name,
                          value: res.data.data.SYJ003[i].name,
                      })
                  }
                  this.qwyyObj = {
                          text: res.data.data.SYJ003[0].name,
                          title: res.data.data.SYJ003[0].name,
                          value: res.data.data.SYJ003[0].name,
                      }
              }
          })
      },
      confirmTx() {
          this.showTxDialog = false
      },
      callPhone(e) {
          window.location.href = "tel://" + e;
      },
      formatRealName() {
          this.realName = this.deleteNum(this.realName);
      },
      deleteNum(str) {
          let reg = /[0-9]+/g;
          let str1 = str.replace(reg, "");
          return str1;
      },
      onsjdConfirm(value) {
          this.qwrqText = lsDate + " " + value;
          this.showQwrqPopup = false;
      },
      onsjdCancel() {
          this.showQwrqPopup = false;
          this.showCalendar = true;
          // this.qwrqText = ""
      },
      selectCalendar(e) {
          lsDate = this.getNextDate(e, 0);
          if(this.dateType == 'jfrq') {
            this.qwrqText = lsDate
          } else {
            this.ccrq = lsDate
          }
          this.showCalendar = false;
          // this.showQwrqPopup = true;
      },
      selQwrq() {
          this.dateType = "jfrq"
          this.showCalendar = true;
      },
      selCcrq() {
        this.dateType = "ccrq"
          this.showCalendar = true;
      },
      getNextDate(date, day) {
          var dd = new Date(date);
          dd.setDate(dd.getDate() + day);
          var y = dd.getFullYear();
          var m =
              dd.getMonth() + 1 < 10
                  ? "0" + (dd.getMonth() + 1)
                  : dd.getMonth() + 1;
          var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
          return y + "-" + m + "-" + d;
      },
      time_range(beginTime, endTime) {
          var strb = beginTime.split(":");

          if (strb.length != 2) {
              return false;
          }

          var stre = endTime.split(":");
          if (stre.length != 2) {
              return false;
          }

          var b = new Date();
          var e = new Date();
          var n = new Date();

          b.setHours(strb[0]);
          b.setMinutes(strb[1]);
          e.setHours(stre[0]);
          e.setMinutes(stre[1]);

          if (
              n.getTime() - b.getTime() > 0 &&
              n.getTime() - e.getTime() < 0
          ) {
              return true;
          } else {
              return false;
          }
      },
      jsidCard() {
          if (
              this.idCardNumber.length == 18 ||
              this.idCardNumber.length == 15
          ) {
              let ageAndsex = this.analyzeIDCard(
                  this.idCardNumber.length,
                  this.idCardNumber
              );
              this.age = ageAndsex.age;
              this.sex = ageAndsex.sex;
          }
      },
      initData() {
          let zjlxPro = new Promise((resolve, reject) => {
              user.getMasterData("H20503")
                  .then((res) => {
                      let lsList = [];
                      for (let i in res.data.result) {
                          lsList.push({
                              text: res.data.result[i]
                                  .nationalStandardMeaning,
                              title: res.data.result[i]
                                  .nationalStandardMeaning,
                              value: res.data.result[i]
                                  .nationalStandardValues,
                          });
                      }
                      resolve(lsList);
                  })
                  .catch(() => {
                      reject();
                      this.isLoading = false;
                  });
          });

          let qwyyPro = new Promise((resolve, reject) => {
              user.getMasterData("Z90010")
                  .then((res) => {
                      let lsList = [];
                      for (let i in res.data.result) {
                          lsList.push({
                              text: res.data.result[i]
                                  .nationalStandardMeaning,
                              title: res.data.result[i]
                                  .nationalStandardMeaning,
                              value: res.data.result[i]
                                  .nationalStandardValues,
                          });
                      }
                      resolve(lsList);
                  })
                  .catch(() => {
                      reject();
                      this.isLoading = false;
                  });
          });
          Promise.all([zjlxPro, qwyyPro])
              .then((res) => {
                  this.zjlxCom = res[0];
                  this.qwyyCom = res[1];
                  //   this.qwyyCom.splice(2,1)

                  this.slhCom = res[1][2];
                  this.allQwyyCom = res[1];
                  this.getWxHisInfo();
              })
              .catch((err) => {
                  console.log(err);
              });
      },
      getWxUserInfo() {
          user.wxUserInfo().then((res) => {
              if (res.data.code == 200) {
                  if(res.data.result.name!=null) {
                      this.realName = res.data.result.name
                      this.zjlxObj = {
                              text: '居民身份证',
                              title: '居民身份证',
                              value: 1,
                      }
                      this.idCardNumber = res.data.result.certificateNumber
                      this.mobile = res.data.result.phone
                      this.jsidCard()
                  }
              }
              this.isLoading = false;
          });
      },
      clearAll() {
          this.realName = ""
          this.zjlxObj = {}
          this.mobile = ""
          this.idCardNumber = ""
          this.age = ""
          // this.jsidCard()
      },
      getWxHisInfo() {
          let params = {
              faqi_id: this.getQueryString("id"),
          };
          user.getWritedByFq(params).then((res) => {
              if (res.data.code == 200) {
                  if (res.data.data == null) {
                      this.failEdit = true
                      this.status = 0;
                      if(localStorage.getItem('lastuser')) {
                          Toast('已为您自动同步了上次填写的信息')
                          this.realName = JSON.parse(localStorage.getItem('lastuser')).realName
                          this.zjlxObj = JSON.parse(localStorage.getItem('lastuser')).zjlxObj
                          this.mobile = JSON.parse(localStorage.getItem('lastuser')).mobile
                          this.idCardNumber = JSON.parse(localStorage.getItem('lastuser')).idCardNumber
                          this.jsidCard()
                      }
                      this.hisId = ""
                  } else {
                      if(res.data.data.user_id != JSON.parse(localStorage.getItem("user")).id) {
                          this.failEdit = false;
                      } else {
                          this.status = res.data.data.status;
                          this.realName = res.data.data.patient_name;
                          this.zjlxObj = {
                              text: res.data.data.id_type,
                              title: res.data.data.id_type,
                              value: res.data.data.id_type    
                          }
                          this.qwyyObj = {
                              text: res.data.data.qwjzyy,
                              title: res.data.data.qwjzyy,
                              value: res.data.data.qwjzyy    
                          }
                          this.idCardNumber = res.data.data.id_card;
                          this.mobile = res.data.data.mobile;
                          this.hisId = res.data.data.id;
                          this.age = res.data.data.age;
                          this.sex = res.data.data.sex;
                          this.qwrqText = res.data.data.qwjzrq;
                          this.remarks =  res.data.data.remarks;
                          this.jzlb = res.data.data.jzlb;
                          this.jyjcbgList =
                              res.data.data
                                  .jzjybg == ""
                                  ? []
                                  : this.getImgList(
                                      res.data.data
                                          .jzjybg
                                  );
                          this.jyjcbgStringList =
                              res.data.data
                                  .jzjybg == ""
                                  ? []
                                  : this.getImgList1(
                                      res.data.data
                                          .jzjybg
                                  );
                      }
                  }
              }
              this.isLoading = false;
          });
      },
      getImgList(e) {
          if(e != null) {
              // let rtList = [];
              let imgs = e.split(",");
              // for (let i in imgs) {
              //     rtList.push(Config.resource.base + imgs[i] + '?token=' + this.token);
              // }
              return imgs;
          } else {
              return []
          }
      },
      getImgList1(e) {
          if(e != null) {
              // let rtList = [];
              let imgs = e.split(",");
              // for (let i in imgs) {
              //     rtList.push(imgs[i]);
              // }
              return imgs;
          } else {
              return []
          }
      },
      getzjlx(e) {
          for (let i in this.zjlxCom) {
              if (e == this.zjlxCom[i].value) {
                  return this.zjlxCom[i];
              }
          }
      },
      getqwyy(e) {
          for (let i in this.allQwyyCom) {
              if (e == this.allQwyyCom[i].value) {
                  return this.allQwyyCom[i];
              }
          }
      },
      submitOrEditData() {
          if (this.productName == "") {
              Toast.fail("请填写产品名称");
              return;
          }
          if (this.productPrice == "") {
              Toast.fail("请填写产品价格");
              return;
          }
          if (this.specModel == "") {
              Toast.fail("请填写规格型号");
              return;
          }
          if (this.ccrq == "") {
              Toast.fail("请选择出厂日期");
              return;
          }
        //   if (this.xh == "") {
        //       Toast.fail("请选择机器序号");
        //       return;
        //   }
          if (JSON.stringify(this.zjlxObj) == "{}") {
              Toast.fail("请选择质保年限");
              return;
          }
        //   if (this.qwrqText == "") {
        //       Toast.fail("请选择交付日期");
        //       return;
        //   }
          
          if (JSON.stringify(this.customerObj) == "{}") {
              Toast.fail("请填写客户名称");
              return;
          }
        //   if (this.customerMobile == "") {
        //       Toast.fail("请填写联系方式");
        //       return;
        //   }

          if (this.saleId == "") {
              this.submitData();
          } else {
              this.editData();
          }
          
      },
      convertToUpperCase(idNumber) {
          return idNumber.toLocaleUpperCase(); // 使用 toLocaleUpperCase() 函数将所有字符转换为大写
      },
      submitData() {
          this.isLoading = true;
          let params = {
              productName: this.productName,
              productPrice: this.productPrice,
              specModel: this.specModel,
              warrantyDate: this.zjlxObj.value,
            //   deliveryDate: "",
              customerName: this.customerObj.name,
              customerMobile: this.customerObj.mobile,
              remarks: this.remarks,
              dkzyj: this.dkzyj,
              sxby: this.sxby,
              ccrq: dayjs(this.ccrq).format("YYMMDD"),
              xh: this.xh,
          };
          user.addSale(params).then((res) => {
            this.isLoading = false;
              if (res.data.code == 200) {
                Toast.success("新增成功");
                this.$router.back()
              } else {
                  Toast.fail(res.data.message);
              }
          });
      },
      editData() {
          this.isLoading = true;
          let params = {
            
              id: this.saleId,
              productName: this.productName,
              productPrice: this.productPrice,
              specModel: this.specModel,
              warrantyDate: this.zjlxObj.value,
            //   deliveryDate: this.qwrqText,
              customerName: this.customerObj.name,
              customerMobile: this.customerObj.mobile,
              remarks: this.remarks,
              dkzyj: this.dkzyj,
              sxby: this.sxby,
              ccrq: dayjs(this.ccrq).format("YYMMDD"),
              xh: this.xh,
          };
          user.editSale(params).then((res) => {
            this.isLoading = false;
              if (res.data.code == 200) {
                  Toast.success("编辑成功");
                this.$router.back()
              } else {
                  Toast.fail(res.data.message);
              }
          });
      },
      analyzeIDCard(val, idcar) {
          let iden = idcar;
          let sex = null;
          let myDate = new Date();
          let month = myDate.getMonth() + 1;
          let day = myDate.getDate();
          let age = 0;
          let sumData = {};
          if (val === 18) {
              age = myDate.getFullYear() - iden.substring(6, 10) - 1;
              sex = iden.substring(16, 17);

              if (
                  iden.substring(10, 12) < month ||
                  (iden.substring(10, 12) == month &&
                      iden.substring(12, 14) <= day)
              )
                  age++;
          }
          if (val === 15) {
              age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
              sex = iden.substring(14, 15);

              if (
                  iden.substring(8, 10) < month ||
                  (iden.substring(8, 10) == month &&
                      iden.substring(10, 12) <= day)
              )
                  age++;
          }
          // if (sex % 2 === 0) sex = "0";
          // else sex = "1";
          sumData = {
              age: age,
              sex: sex,
          };
          return sumData;
      },
      // 获取下拉框数据
      getidCardByCode() {
          this.zjlxCom = [];
          user.getMasterData("H20503")
              .then((res) => {
                  for (let i in res.data.result) {
                      this.zjlxCom.push({
                          text: res.data.result[i].nationalStandardMeaning,
                          title: res.data.result[i].nationalStandardMeaning,
                          value: res.data.result[i].nationalStandardValues,
                      });
                  }
                  // this.zjlxCom = lsList
                  this.isLoading = false;
                  this.showZjlxPopup = true;
              })
              .catch(() => {
                  this.isLoading = false;
              });
      },
      // 获取下拉框数据
      getQwHospitalByCode() {
          let lsList = [];
          user.getMasterData("Z90010")
              .then((res) => {
                  for (let i in res.data.result) {
                      lsList.push({
                          text: res.data.result[i].nationalStandardMeaning,
                          title: res.data.result[i].nationalStandardMeaning,
                          value: res.data.result[i].nationalStandardValues,
                      });
                  }
                  lsList.splice(2, 1);
                  this.jzyyCom = lsList;
                  this.slhCom = lsList[2];
                  this.isLoading = false;
                  this.showQwyyPopup = true;
              })
              .catch(() => {
                  this.isLoading = false;
              });
      },
      upLoadImg(e) {
          let file = e.target.files[0];
          let fd = new FormData();
          fd.append("file", file);
          this.uploadImg(fd);
          // console.log(file);
          // this.compressImg(file);
          // let fd = new FormData()
          // fd.append('file', file)
          // this.uploadFile(fd, s)
      },
      uploadImg(fd) {
          // let params = {
          //     file: fd,
          //     biz: 'temp'
          // };
          this.isLoading = true;
          user.upLoadFile(fd)
              .then((res) => {
                  console.log(res);
                  this.jyjcbgList.push(
                      res.data.data.src
                  );
                  this.jyjcbgStringList.push(res.data.data.src);
                  this.isLoading = false;
              })
              .catch(() => {
                  this.isLoading = false;
              });
      },
      getQueryString: function (name) {
          let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
          let r = window.location.search.substr(1).match(reg);
          if (r != null) {
              return unescape(decodeURI(r[2]));
          }
      },
      delPic(index) {
          this.jyjcbgList.splice(index, 1);
          this.jyjcbgStringList.splice(index, 1);
      },
      showPic(index) {
          ImagePreview(this.jyjcbgList, index);
      },
      gzxqdClick(e) {
          this.$router.push({ name: "gzxqd", query: e });
      },
      isUserSex(e) {
          this.sex = e;
      },
      isUserDkzyj(e) {
          this.dkzyj = e;
      },
      isUserSxby(e) {
          this.sxby = e;
      },
      isJzlb(e) {
          this.jzlb = e;
      },
      isJzxq(e) {
          this.jzxq = e;
      },
      parentData(e) {
          this.isSel = e;
      },
      selZjlx() {
          this.showZjlxPopup = true;
      },
      selCustomer() {
          this.showCustomerPopup = true;
      },
      selQwyy() {
          this.showQwyyPopup = true;
      },
      onConfirm(value) {
          this.zjlx = value.text;
          this.zjlxObj = value;
          this.showZjlxPopup = false;
      },
      onCancel() {
          this.showZjlxPopup = false;
      },
      onConfirm1(value) {
          this.qwyy = value.text;
          this.qwyyObj = value;
          this.showQwyyPopup = false;
      },
      onCancel1() {
          this.showQwyyPopup = false;
      },
      changeDzms() {
          if(this.fontSizeValue == 0) {
              this.fontSizeValue = 8;
          } else {
              this.fontSizeValue = 0;
          }
          
      },
  },
};
</script>
<style scoped>
.pub-input{
  font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;margin-top: 10px;
}
/deep/ .van-calendar__confirm {
  height: 45px !important;
  font-size: 16px;
}
.boda {
  width: 20px;
  height: 20px;
  font-size: 12px;
  background: rgba(236, 154, 48, 0.6);
  padding: 2px 5px;
  border-radius: 3px;
  color: #fff;
  margin-left: 10px;;
}
.info-box {
  width: 92%;
  margin-left: 4%;
  padding: 5px 0 10px 0;
}
input {
  padding: 0;
}
textarea {
  padding: 0;
}
.box-margin {
  width: 92%;
  margin-left: 4%;
  position: relative;
  top: 10px;
}
.bg-title {
  width: 100%;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.x-box1 .img-list:nth-child(4) {
  margin-right: 0;
}

.x-box1 .img-list:nth-child(8) {
  margin-right: 0;
}
.img-list {
  position: relative;
  width: 44px;
  height: 44px;
  margin-bottom: 8px;
  margin-right: 2%;
}
.dele {
  width: 22px;
  height: 22px;
  position: absolute;
  top: -7px;
  right: -7px;
  background: #fff;
  border: 2px solid #fff;
  border-radius: 50%;
}
.add-img1 {
  position: relative;
  width: 44px;
  display: flex;
  align-items: center;
  height: 44px;
  margin-bottom: 7px;
}

.file {
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #1e88c7;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  width: 100%;
  height: 87px;
  align-items: center;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file input {
  width: 100%;
  height: 87px;
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}

.file:hover {
  color: #004974;
  text-decoration: none;
}

.img-size1 {
  width: 21px;
  height: 18px;
}
.box {
  height: 100vh;
  position: static;
  background: #eef7f8;
}
.bar {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.box-item:last-child {
  border-bottom: none;
}
.share-url {
  width: 92%;
  margin-left: 4%;
  height: 49px;
  background: linear-gradient( 103deg, #FE9E3C 0%, #FF8424 100%);
  line-height: 49px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  border-radius: 8px;
  margin-top: 15px;
  cursor: pointer;
}
.content-box {
  width: 100%;
  margin-top: 7px;
  background: #fff;
  padding-bottom: 15px;
  border-radius: 8px;
  padding-top: 5px;
}
.box-item {
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 19px;
  /* border-bottom: 1px solid #f2f2f2; */
}
.box-item2 {
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 19px;
  /* border-bottom: 1px solid #f2f2f2; */
}
.box-item3 {
  /* height: 121px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 19px;
  /* border-bottom: 2px solid #f2f2f2; */
}
.box-item4 {
  /* height: 121px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 2px solid #f2f2f2; */
  background: #3985DE;
  padding: 10px;
  border-radius: 8px;
  color: #fff;
  font-size: 12px;;
  box-sizing: border-box;
  margin-top: 19px;
}
.box-item6 {
  /* height: 121px; */
  position: absolute;
  left: 0;
  top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 2px solid #f2f2f2; */
  background: rgba(236, 165, 48, 0.76);
  padding: 5px 10px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  color: #fff;
}
.box-item3 > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
  /* margin-top: 15px; */
  margin-bottom: 10px;
}
.box-item3 > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.box-item2 > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item2 > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.box-item > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.box-item1 {
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 1px solid #f2f2f2; */
  margin-top: 19px;
}
.box-item1 > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item1 > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 8px;
  justify-content: space-between;
}
.btm-icon {
  width: 12px;
  margin-right: 15px;
}
.title {
  font-size: 15px;
  color: #c0c0c0;
  margin-left: 14px;
}
.user-type {
width: 48%;
display: flex;
align-items: center;
text-align: center;
line-height: 44px;
cursor: pointer;
/* margin-right: 15px; */
/* margin-top: 14px; */
border-radius: 8px;
font-family: PingFang-SC, PingFang-SC;
font-weight: 500;
font-size: 14px;
color: #333333;
text-align: center;
font-style: normal;
}
.user-type1 {
width: 31%;
display: flex;
align-items: center;
text-align: center;
line-height: 44px;
cursor: pointer;
/* margin-right: 15px; */
/* margin-top: 14px; */
border-radius: 8px;
font-family: PingFang-SC, PingFang-SC;
font-weight: 500;
font-size: 14px;
color: #333333;
text-align: center;
font-style: normal;
}
.redbtn-icon {
  width: 18px;
  margin-right: 8px;
}
.input-gh {
  width: 80%;
  border: none;
  /* margin-top: 8px; */
  font-size: 15px;
  padding: 0 14px;
  box-sizing: border-box;
  background: #00000000;
}
.input-xq {
  width: 100%;
  border: none;
  margin-top: 8px;
  height: 66px;
  font-size: 15px;
  resize: none;
}
input::placeholder {
  color: #c0c0c0;
}
textarea::placeholder {
  color: #c0c0c0;
}
.list-item {
  margin-bottom: 10px;
}
.leftbtn {
  display: flex;
  align-items: center;
}
.gzxqd {
  height: 26.5px;
  border: 1px solid #079bab;
  color: #079bab;
  line-height: 26.5px;
  font-size: 12px;
  text-align: center;
  padding: 0 10px;
  border-radius: 26px;
}
.yjqk {
  position: fixed;
  top: 300px;
  right: 0;
  background: #3985DE;
  padding: 5px 10px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  color: #fff;
  z-index: 99;
  font-size: 14px;
}
.box-dzms{position: absolute;top: 20px;;right: 0;display: flex;align-items: center;justify-content: center;border: 1px solid #079bab;padding: 2px 5px;border-radius: 35px;font-size: 12px;color: #00AC97;}
.ips {
	width: 92%;height: 32px;border: none;border-radius: 50px;padding: 0 15px;box-sizing: border-box;font-family: PingFang-SC, PingFang-SC;font-weight: 500;font-size: 14px;color: #4B4D4D;line-height: 20px;text-align: left;font-style: normal;
}
</style>
